/**
 * Moment de la journée pour les fonds à ambiance « automatique » (Voyageur, Oiseau) : un seul calcul, réglable depuis le tableau de
 * bord (carte « Fond du bandeau ») et calé par défaut sur les horaires du magasin (ouvert de 9 h à 18 h). Aerith tourne toute la
 * journée : le fond est en pleine lumière en début d'ouverture, prend les couleurs du soir les deux dernières heures avant la
 * fermeture, puis passe en nuit jusqu'au jour suivant. Calcul seulement (testable).
 */

/** Heures pleines (0 à 23) à partir desquelles c'est le jour, le crépuscule, puis la nuit : 9 h, 16 h, 18 h par défaut. */
export const HORAIRES_DEFAUT = {jour: 9, crepuscule: 16, nuit: 18};

/** Vrai si les trois heures sont des entiers de 0 à 23 qui se suivent : jour < crépuscule < nuit. */
export function horairesValides(h) {
    if (!h) return false;
    const heures = [h.jour, h.crepuscule, h.nuit];
    return heures.every(x => Number.isInteger(x) && x >= 0 && x <= 23) && h.jour < h.crepuscule && h.crepuscule < h.nuit;
}

/** Horaires utilisables : ceux donnés s'ils sont valides, sinon ceux par défaut. */
export const horairesOuDefaut = h => (horairesValides(h) ? h : HORAIRES_DEFAUT);

/** « jour » dès l'heure du jour, « soir » (crépuscule) dès celle du crépuscule, « nuit » dès celle de la nuit et jusqu'au jour suivant. */
export function momentDeLaJournee(date, horaires) {
    const h = date.getHours(), t = horairesOuDefaut(horaires);
    if (h >= t.jour && h < t.crepuscule) return "jour";
    if (h >= t.crepuscule && h < t.nuit) return "soir";
    return "nuit";
}
